import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // allowBack: false
    pageName: '',
  },
  mutations: {
    setPageName(state, data) {
      /**
       *testData是state内需要被修改的数据
       *data是传来的数据
       */
      state.pageName = data;
    },
  },
  actions: {

  }
})
